import { DataModel } from "common/models/utility-models/base-model";


export class UploadFileModel extends DataModel {
  isAnnual: 0 | 1 = 0;
  periodValue: string = '';
  fileName: string = '';
  uploadedFileOriginalName: string = '';
  documentTypeId: string = '';
  uploadDocId: string = '';
  filePath: string = '';
  uploadedFileName: string = '';
}
